import React from 'react';
import styled from 'styled-components';
import { brandColours, fontSize } from '../../styles';

const StyledOverline = styled.p`
  color: ${brandColours.secondary};
  ${fontSize(18)};
`;

export const Overline = ({ children, ...props }) => (
  <StyledOverline {...props}>{children}</StyledOverline>
);
